import { FDealType } from '../../../../../../../packages/JsonQuery';
import { useSelector } from 'react-redux';
import { FC } from 'react';
import { selectDealType } from 'shared/selectors/jsonQuery';
import {
  RentLongObjectTypeContainer,
  SaleObjectTypeContainer,
} from 'shared/containers/AdvancedFiltersContainer/containers/AdvancedFiltersContentContainer/containers/ObjectTypeContainer/containers';
import { RentDailyObjectTypeContainer } from './containers/RentDailyObjectTypeContainer/RentDailyObjectTypeContainer';

export const ObjectTypeContainer: FC = () => {
  const dealType = useSelector(selectDealType);

  if (dealType === FDealType.Sale) {
    return <SaleObjectTypeContainer />;
  }

  if (dealType === FDealType.RentLongterm) {
    return <RentLongObjectTypeContainer />;
  }

  if (dealType === FDealType.RentDaily) {
    return <RentDailyObjectTypeContainer />;
  }

  return null;
};
